import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CopyIcon from '../../../../../../../themes/svg/copyIcon';
import { useModalProviderContext } from '../../../../../../ModalProvider';
import { copyStylesModal } from '../../../../../../ModalProvider/modalNames';
import clearValidation from '../../../../../../../actions/copyStyles/clearValidation';


const CopyStyle = ({ itemId, clearCopyStyleValidation }) => {
  const { setIsOpen } = useModalProviderContext(copyStylesModal);

  const openModal = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    clearCopyStyleValidation();
    setIsOpen(true, { itemId });
  }, [setIsOpen, itemId]);

  return (
    <div
      className="actionBarItem copyStyles desktop-tablet-only"
      onClick={openModal}
      tabIndex="-1"
      role="button"
    >
      <div className="actionBarIcon">
        <CopyIcon />
      </div>{' '}
      <span className="label link">Copy Style</span>
    </div>
  );
};
CopyStyle.propTypes = {
  itemId: PropTypes.string.isRequired,
  clearCopyStyleValidation: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  clearCopyStyleValidation: clearValidation,
};

export default connect(null, mapDispatchToProps)(CopyStyle);
